import { render, staticRenderFns } from "./Answers.vue?vue&type=template&id=5c83cb22&"
import script from "./Answers.vue?vue&type=script&lang=ts&"
export * from "./Answers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports